export var INTERNAL_DOMAIN_TYPE = 'internal';
export var EXTERNAL_DOMAIN_TYPE = 'external';
export var NOTIFICATION_TEMPLATE_NAME = 'domain_submission';